// extracted by mini-css-extract-plugin
export default {"principal":"HomePage_principal__gw5db"};